module.exports = __webpack_public_path__ + "static/media/rnaui_104.2202b764.ico";